import PropTypes from 'prop-types';
import ExamQuestionFormats from './ExamQuestionFormats';

export default PropTypes.shape({
  certificacionWithExam: PropTypes.bool,
  color: PropTypes.string,
  examCompletionTimeLimit: PropTypes.number,
  examQuestionFormats: ExamQuestionFormats,
  linkToPracticeExam: PropTypes.string,
  minimumApprovalLevel: PropTypes.number,
  numberOfExamQuestions: PropTypes.number,
});
